import { css } from 'react-emotion'

const styles = {
  logo: css({
    margin: '2px 7px',
    height: '48px',
    width: '48px',
    position: 'relative',
    backgroundColor: '#7A68F2',
    borderRadius: '50%',
    boxSizing: 'border-box',
    cursor: 'pointer'
  }),
  logoImg: css({
    margin: '0',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-55%, -45%)'
  }),
  settingsMenu: css({
    zIndex: '255 !important'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/NavBarStyles.js